import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Coffee, CheckSquare, BarChart2, Plus } from 'lucide-react';
export function OfferStack() {
  const items = [{
    icon: <BookOpen className="h-6 w-6 text-terracotta" data-id="element-220" />,
    title: 'PequeSalud Natural — Guía Principal',
    price: '$19 USD'
  }, {
    icon: <Coffee className="h-6 w-6 text-terracotta" data-id="element-221" />,
    title: 'Bono #1: Mini Recetario de Bebidas Saludables',
    price: '$12 USD'
  }, {
    icon: <CheckSquare className="h-6 w-6 text-terracotta" data-id="element-222" />,
    title: 'Bono #2: Checklist de Salud PequeSalud',
    price: '$12 USD'
  }, {
    icon: <BarChart2 className="h-6 w-6 text-terracotta" data-id="element-223" />,
    title: 'Bono #3: Tabla Comparativa de Síntomas',
    price: '$12 USD'
  }];
  return <section className="py-24 bg-forest text-cream relative overflow-hidden" data-id="element-224">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" data-id="element-225">
        <div className="absolute right-0 top-0 w-96 h-96 bg-white rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" data-id="element-226"></div>
        <div className="absolute left-0 bottom-0 w-96 h-96 bg-terracotta rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2" data-id="element-227"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-228">
        <div className="text-center mb-16" data-id="element-229">
          <h2 className="text-3xl md:text-5xl font-bold font-serif mb-6" data-id="element-230">
            Todo lo que recibes hoy:
          </h2>
          <div className="h-1 w-24 bg-terracotta mx-auto rounded-full" data-id="element-231"></div>
        </div>

        <div className="bg-white/5 backdrop-blur-sm rounded-3xl border border-white/10 overflow-hidden shadow-2xl" data-id="element-232">
          <div className="p-8 md:p-12 space-y-6" data-id="element-233">
            {items.map((item, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="flex items-center justify-between border-b border-white/10 pb-6 last:border-0 last:pb-0" data-id="element-234">
                <div className="flex items-center gap-4" data-id="element-235">
                  <div className="bg-cream/10 p-3 rounded-xl hidden sm:block" data-id="element-236">
                    {item.icon}
                  </div>
                  <span className="text-lg md:text-xl font-medium" data-id="element-237">
                    {item.title}
                  </span>
                </div>
                <span className="text-lg font-bold text-terracotta-light whitespace-nowrap ml-4" data-id="element-238">
                  {item.price}
                </span>
              </motion.div>)}
          </div>

          <div className="bg-terracotta/20 p-8 md:p-12 border-t border-white/10" data-id="element-239">
            <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-center md:text-left" data-id="element-240">
              <div data-id="element-241">
                <p className="text-cream/60 text-sm uppercase tracking-widest font-bold mb-2" data-id="element-242">
                  Valor Total del Paquete
                </p>
                <p className="text-3xl font-bold line-through opacity-50 decoration-terracotta decoration-2" data-id="element-243">
                  $55 USD
                </p>
              </div>

              <div className="hidden md:block" data-id="element-244">
                <ArrowRightLong data-id="element-245" />
              </div>

              <div className="bg-white text-forest px-8 py-4 rounded-2xl shadow-xl transform scale-110" data-id="element-246">
                <p className="text-xs uppercase tracking-widest font-bold text-terracotta mb-1" data-id="element-247">
                  Tú lo obtienes hoy por solo
                </p>
                <p className="text-4xl md:text-5xl font-bold font-serif" data-id="element-248">
                  $6,39 USD
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center max-w-2xl mx-auto" data-id="element-249">
          <p className="text-xl font-serif italic text-cream/80" data-id="element-250">
            "Las personas no compran porque tu servicio es 'bueno.' Compran
            porque es claro, completo y seguro."
          </p>
        </div>
      </div>
    </section>;
}
function ArrowRightLong() {
  return <svg width="60" height="24" viewBox="0 0 60 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-terracotta opacity-50" data-id="element-251">
      <path d="M0 12H58M58 12L48 2M58 12L48 22" stroke="currentColor" strokeWidth="2" data-id="element-252" />
    </svg>;
}